<script>
import OrderAPI from "@/services/orders-api";
import OrderTableDetails from "@/components/OrderTableDetails.vue";
import MenuApi from "@/services/menu-api";
import Swal from "sweetalert2";
import bellSound from '@/assets/sounds/restaurant-bell.mp3';
import TableShimmer from "@/components/TableShimmer.vue";
import Footer from "@/components/footer";
import MobileFooter from "@/components/mobile-login-footer"

export default {
  components: {OrderTableDetails, TableShimmer, Footer, MobileFooter},
  data() {
    return {
      orders: {},
      ordersIntervalId: null,
      codeMenu:null,
      selectedStatus:1,
      selectedOrderTable:null,
      isMobile: false,
      showModalOrderDetails:false,
      isFilterByCallWaiter:false,
      isFilterByResto:false,
      isFilterByOnline:false,
      orderTableDetailsKey:0,
      bellAudio: null,
      bellSoundEnabled: false,
      itemsList:[],
      ordersError:false
    };
  },

  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);

    this.getItems()
    this.getOrders(false);
    this.ordersIntervalId = setInterval(() => {
      this.getOrders(true);
    }, 30000);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
    if (this.ordersIntervalId) {
      clearInterval(this.ordersIntervalId);
    }
  },

  watch :{
    '$route': {
        immediate: true,
        deep: false, 
        handler(route) {
        this.codeMenu = route.params.code;
        }
    },

    filteredTables: function(){
      if(this.filteredTables == null || this.filteredTables.length == 0){
        this.closeDetails()
      }
    }
  },

  computed: {
  filteredTables() {
    if (!this.orders || !this.orders.tables) return [];

    let filteredTables = [...this.orders.tables];


    if (this.selectedStatus !== null) {
      if (this.selectedStatus === 1) {
        filteredTables = filteredTables.filter(table => table.status != null);
      } else {
        filteredTables = filteredTables.filter(table => table.status === this.selectedStatus || table.isCallWaiter );
      }
    }

    if (this.isFilterByCallWaiter) {
      filteredTables = filteredTables.filter(table => table.isCallWaiter === true);
    }

    if (this.isFilterByOnline) {
      filteredTables = filteredTables.filter(table => table.tableNumber > 100000);
    }

    if (this.isFilterByResto) {
      filteredTables = filteredTables.filter(table => table.tableNumber < 100000);
    }

    return filteredTables;
  },

    selectedTableNumber(){
      return this.selectedOrderTable == null ? null : this.selectedOrderTable.tableNumber;
    }
  },

  methods: {

    getItems(){
      MenuApi.getMenuItemsByMenuCode(this.codeMenu).then((result) =>{
        if(result){
          this.itemsList = result;
        }
      })
    },

    archivedAll() {
      Swal.fire({
        title: `<span style="color:#d33; font-weight:bold; font-size: 22px;" class="text-uppercase">
                  ${this.$t("menuOrder.order.button.archivedAll")}
                </span>`,
        html: `<div style="font-size: 16px; padding-top: 10px;">
                ${this.$t("menuOrder.order.ordersConfirmArchiveText")}
              </div>`,
        icon: "warning",
        iconColor: "#d33",
        background: "#fff3f3",
        showCancelButton: true,
        confirmButtonColor: "#c62828",
        cancelButtonColor: "#6c757d",
        confirmButtonText: `${this.$t("menuOrder.order.button.archivedAll")}`,
        cancelButtonText: `${this.$t("menuOrder.order.button.cancel")}`,
        reverseButtons: true,
        backdrop: `rgba(255,0,0,0.2)`
      }).then((result) => {
        if (result.isConfirmed) {

          OrderAPI.archivedAll(this.codeMenu)
            .then(response => {
              this.orders = response;
              if (this.selectedOrderTable != null) {
                this.selectedOrderTable = this.orders.tables.find(
                  o => o.tableNumber == this.selectedTableNumber
                );
              this.$refs.orderDetailsRef?.refreshDetails(this.selectedOrderTable);
              }

              Swal.fire({
                icon: "success",
                title: `${this.$t("menuOrder.order.ordersArchivedTitle")}`,
                html: `<div style="font-size: 16px;">${this.$t("menuOrder.order.ordersArchivedSuccessMessage")}</div>`,
                background: "#f0fff4",
                showConfirmButton: false,
                timer: 3000,
              });
            })
            .catch(error => {
              Swal.fire({
                icon: "error",
                title: `${this.$t("menuOrder.order.archivedErrorTitle")}`,
                html: `<div style="font-size: 16px; color: #d32f2f;">${this.$t("menuOrder.order.archivedErrorMessage")}</div>`,
                background: "#ffebee"
              });
              console.error(error);
            });
        }
      });
    },

    refresh(){
      this.getOrders(false);
    },

    closeDetails(){
      this.showModalOrderDetails = false
      this.selectedOrderTable = null

    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 576; 
    },

    getOrderTableDetails(table){
      this.selectedOrderTable = table
      if(this.isMobile){
        this.showModalOrderDetails = true
      }
    },

    filterByCallWaiter(){
      this.isFilterByCallWaiter = !this.isFilterByCallWaiter
    },

    filterByOnline(){
      this.isFilterByOnline = !this.isFilterByOnline
      this.isFilterByResto = false

    },
    filterByResto(){
      this.isFilterByResto = !this.isFilterByResto
      this.isFilterByOnline = false

    },

    filterByStatus(status) {
      if(this.selectedStatus && this.selectedStatus == status){
        this.selectedStatus = null;
      }else{
        this.selectedStatus = status;
        this.isFilterByCallWaiter = false
        // this.isFilterByResto = false
        // this.isFilterByOnline = false
      } 
    },



    getOrders(playBellSoundIsActif) {
      this.ordersError = false
      OrderAPI.getOrders(null, this.codeMenu)
        .then(response => {
          this.orders = response.data;

          if(this.orders && this.orders.countOpen > 0){
           
              if(this.orders.countNew > 0 || this.orders.countCallWaiter > 0){
                try {
                    this.playBellSound(playBellSoundIsActif, this.orders.tableNumbersByStatus);
                } catch (e) {
                  console.error("Notification error:", e);
                }
              }

            if(this.selectedOrderTable != null){
              this.selectedOrderTable = this.orders.tables.find(
                o => o.tableNumber == this.selectedTableNumber
              );

              this.$refs.orderDetailsRef?.refreshDetails(this.selectedOrderTable);

            }
          }

        }).catch(() => {
            this.orders = null
            this.ordersError = true
            this.closeDetails()
        })
    },

    enableBellSound() {
      this.bellAudio = new Audio(bellSound);
      this.bellAudio.load();
      this.bellSoundEnabled = true;
      this.bellAudio.play().catch(() => {});
    },

    playBellSound(playBellSoundIsActif , tableNumbersByStatus) {
      if(playBellSoundIsActif ){
        this.enableBellSound()
        if(this.bellSoundEnabled && this.bellAudio){
          this.bellAudio.currentTime = 0;
          this.bellAudio.play().catch(err => console.error(err));
        }
        this.showBrowserNotification(tableNumbersByStatus)
      }
    },

    showBrowserNotification(tableNumbersByStatus) {
      if (typeof window === "undefined" || !("Notification" in window)) return;
      if (!tableNumbersByStatus) return;

      const notifications = [];

      if (tableNumbersByStatus.new) {
        notifications.push({
          title: this.$t('menuOrder.notifications.newOrdersTitle'),
              body: this.$t('menuOrder.notifications.newOrdersBody', {tables: tableNumbersByStatus.new})
        });
      }

      if (tableNumbersByStatus.callWaiter) {
        notifications.push({
          title: this.$t('menuOrder.notifications.callWaiterTitle'),
          body: this.$t('menuOrder.notifications.callWaiterBody', { tables: tableNumbersByStatus.callWaiter})
        });
      }

      if (notifications.length === 0) return;

      const isFirefox = typeof navigator !== "undefined" && /firefox/i.test(navigator.userAgent);

      const sendNotification = async ({ title, body }) => {
        const options = { body, icon: "/favicon.ico",data: { url: window.location.href }, };

        try {
          const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

          if (isMobileDevice && "serviceWorker" in navigator) {
            const reg = await navigator.serviceWorker.getRegistration();
            if (reg) {
              await reg.showNotification(title, options);
            } else {
              console.warn("No Service Worker registration found. Notification skipped.");
            }
          } else {
            const notification = new Notification(title, options);

            if (!isFirefox) {
              notification.onclick = (event) => {
                event.preventDefault();
                if (document.hidden) window.focus();
              };
            }
          }
        } catch (err) {
          console.error("Failed to show notification:", err);
        }
      };

      if (Notification.permission === "granted") {
        notifications.forEach(sendNotification);
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            notifications.forEach(sendNotification);
          }
        }).catch((err) => console.error("Notification permission error:", err));
      }
    },

    getColorStatus(status, isCallWaiter) {

        if (status != 2 && isCallWaiter) {
            return '#d11010';
          }

      switch (status) {
        case -2:
          return '#d11010'; //call Waiter
        case -1:
          return '#505971'; //all
        case 1:
          return '#28a745';
        case 2:
          return '#fd7e14';
        default:
          return '#ccc';
      }
    },

      getBackgroundActiveColorStatus(status) {
        switch (status) {
          case -2:
            return '#d11010'; //call Waiter
          case -1:
            return '#505971'; //all
          case 1:
            return '#28a745';
          case 2:
            return '#fd7e14';
          default:
            return '#ccc';
        }
      },



    

    getColorStatusBackground(status, isCallWaiter) {

        if (status != 2 && isCallWaiter) {
         return 'linear-gradient(145deg, #fdeaea, #f5d6d6)';
        }

      switch (status) {
        case 1:
          return 'linear-gradient(145deg, #eaf9ea, #d6f5d6)';
        case 2:
          return 'linear-gradient(145deg, #ffeeda, #f5d8b0)';
        default:
          return '';
      }
    },

    hasOrder(table) {
      return table.count > 0;
    },
  },

};
</script>


<template>
  <div class="p-4 dashboard">
    <div class="mb-md-0 mb-5" >
      <div v-if="this.orders" class="row align-items-center text-center text-md-left">
        <div class="col-12 col-md-4 mb-2 mb-md-0">
          <h5 class="section-title text-primary font-weight-bold mb-0 text-uppercase">
            Tables
          </h5>
        </div>

        <div class="col-12 col-md-4 mb-2 mb-md-0 text-center">
          <span class="text-dark font-weight-medium font-size-20 text-uppercase">
            {{ orders.campaignName }}
          </span>
        </div>

        <div class="col-12 col-md-4 text-md-right text-center font-size-14">
          <span class="text-dark font-weight-medium">
            {{ orders.timestamp }}
          </span>
        </div>
      </div>

      <div class="row align-items-start my-4">
        <div class="col-md-12 d-flex flex-wrap">
          <button
            class="btn button-filter  mr-2 mt-2 font-weight-bold text-uppercase p-3"
            :class="['position-relative', 'mx-2', 'mt-2', { active: selectedStatus === null }, isMobile ? 'w-100' : 'w-md-auto']"
            @click="filterByStatus(null)"
            :style="{
              cursor: 'pointer',
              border: '1px solid ' + getColorStatus(-1),
              '--status-font-color': getColorStatus(-1),
              '--status-background-color': getBackgroundActiveColorStatus(-1),
            }"
          >
            {{ $t('menuOrder.order.filter.all') }} ({{ orders && orders.countTotal ? orders.countTotal : ''  }})
          </button>

          <button
            class="btn button-filter mr-2 ml-2 mt-2 font-weight-bold text-uppercase p-3 "
            :style="{
              cursor: 'pointer',
              border: '1px solid ' + getColorStatus(1),
              '--status-font-color': getColorStatus(1),
              '--status-background-color': getBackgroundActiveColorStatus(1),
            }"
            :class="['position-relative', 'mx-2', 'mt-2', { active: selectedStatus === 1 }, isMobile ? 'w-100' : 'w-md-auto']"
            @click="filterByStatus(1)"
          >
            {{ $t('menuOrder.order.filter.open') }}
            <b-badge
              v-if="orders &&  orders.countOpen > 0"
              variant="primary"
              class="position-absolute translate-middle rounded-circle mt-0 font-weight-bold"
              style="font-size:12px; top: -7px;"
            >
              {{ orders && orders.countOpen ? orders.countOpen : '' }}
            </b-badge>
          </button>

          <button
            class="btn button-filter mr-2 ml-2 mt-2 font-weight-bold text-uppercase p-3"
            :style="{
              cursor: 'pointer',
              border: '1px solid ' + getColorStatus(2),
              '--status-font-color': getColorStatus(2),
              '--status-background-color': getBackgroundActiveColorStatus(2),
            }"
            :class="['position-relative', 'mx-2', 'mt-2', { active: selectedStatus === 2 }, isMobile ? 'w-100' : 'w-md-auto']"
            @click="filterByStatus(2)"
          >
            {{ $t('menuOrder.order.filter.new') }}

            <b-badge
              v-if="orders && orders.countNew > 0"
              variant="danger"
              class="position-absolute translate-middle rounded-circle mt-0 font-weight-bold blinking-badge"
              style="font-size:12px; top: -7px;"
            >
              {{ orders && orders.countNew ? orders.countNew : '' }}
            </b-badge>
          </button>

          <button
            class="btn button-filter mr-2 ml-2 mt-2 font-weight-bold text-uppercase p-3"
            :class="['position-relative', 'mx-2', 'mt-2', { active: isFilterByCallWaiter }, isMobile ? 'w-100' : 'w-md-auto']"
            @click="filterByCallWaiter()"
            :style="{
              cursor: 'pointer',
              border: '1px solid ' + getColorStatus(-2),
              '--status-font-color': getColorStatus(-2),
              '--status-background-color': getBackgroundActiveColorStatus(-2),
            }"
            
          >
            {{ $t('menuOrder.order.filter.callWaiter') }} 

            <b-badge
              v-if="orders && orders.countCallWaiter > 0"
              variant="danger"
              class="position-absolute translate-top rounded-circle font-weight-bold blinking-badge "
              style="font-size:12px; top: -7px;"
            >
              {{ orders && orders.countCallWaiter ? orders.countCallWaiter : ''  }}
            </b-badge>

          </button>

          <!-- vurtial tables filter  -->

          <button
            class="btn button-filter mr-2 ml-2 mt-2 font-weight-bold text-uppercase p-3"
            :class="['position-relative', 'mx-2', 'mt-2', { active: isFilterByResto }, isMobile ? 'w-100' : 'w-md-auto']"
            @click="filterByResto()"
            :style="{
              cursor: 'pointer',
              border: '1px solid ' + getColorStatus(-1),
              '--status-font-color': getColorStatus(-1),
              '--status-background-color': getBackgroundActiveColorStatus(-1),
            }"
          >
            {{ $t('menuOrder.order.filter.resto') }} 

            <b-badge
              v-if="orders && orders.countOpenResto > 0"
              variant="info"
              class="position-absolute translate-top rounded-circle font-weight-bold "
              style="font-size:12px; top: -7px;"
            >
              {{ orders && orders.countOpenResto ? orders.countOpenResto : ''  }}
            </b-badge>

          </button>

          <button
            class="btn button-filter mr-2 ml-2 mt-2 font-weight-bold text-uppercase p-3"
            :class="['position-relative', 'mx-2', 'mt-2', { active: isFilterByOnline }, isMobile ? 'w-100' : 'w-md-auto']"
            @click="filterByOnline()"
            :style="{
              cursor: 'pointer',
              border: '1px solid ' + getColorStatus(-1),
              '--status-font-color': getColorStatus(-1),
              '--status-background-color': getBackgroundActiveColorStatus(-1),
            }"
            
          >
            {{ $t('menuOrder.order.filter.online') }} 

            <b-badge
              v-if="orders && orders.countOpenOnline > 0"
              variant="info"
              class="position-absolute translate-top rounded-circle font-weight-bold "
              style="font-size:12px; top: -7px;"
            >
              {{ orders && orders.countOpenOnline ? orders.countOpenOnline : ''  }}
            </b-badge>

          </button>
        </div>

      </div>



      <div class="row d-flex flex-nowrap">
        <div
          class="transition-col-left" style="min-height: 65vh !important;"
          :class="{ 'shrink': !isMobile && selectedTableNumber, 'full': isMobile || !selectedTableNumber }"
        >
          <div v-if=" filteredTables && filteredTables.length" class="row" :class="selectedTableNumber 
                ? 'row-cols-1 row-cols-lg-2 row-cols-xl-4 g-2' 
                : 'row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4'">
            <div
              v-for="table in filteredTables"
              :key="table.tableNumber"
              class="col text-center my-4"
            >
              <div
                class="table-card d-flex flex-column justify-content-center align-items-center mx-xl-4 mx-4 h-100 " 
                :class="{ 'has-order': hasOrder(table) }"
                :style="{
                  cursor: 'pointer',
                  border: '1px solid ' + getColorStatus(table.status , table.isCallWaiter),
                  background: getColorStatusBackground(table.status , table.isCallWaiter),
                  '--status-color': getColorStatus(table.status , table.isCallWaiter),
                }"
                @click="getOrderTableDetails(table)"
              >
                <div class="chair left"></div>
                <div class="chair right"></div>

                <div v-if="!table.isOrderOnline" class="table-shape mb-2">
                  <img
                    class="table-icon"
                    src="@/assets/images/Spoon-fork-knife-icon.png"
                    alt="Table Icon"
                    width="60"
                    height="60"
                  />
                </div>

                <div  v-if="table.isOrderOnline" class="text-uppercase font-weight-bold mt-4"> Commande en Ligne </div>
                <div v-else class="text-uppercase font-weight-bold">Table {{ table.tableNumber }}</div>

                <div  v-if="table.isOrderOnline" class="mb-2 p-3 rounded-3">
                  <div class="text-primary font-size-14" style="letter-spacing: 0.7px;">
                    <div class="font-weight-bold">{{ table.name }}</div>
                    <div class="font-weight-bold">{{ table.phone }}</div>
                  </div>
                </div>

                <div v-if="hasOrder(table)" class="order-indicator">
                </div>

                <div v-if="table.isCallWaiter" class="waiter-j-call">
                  <img src="@/assets/icons/waiter-j.svg" height="30" alt="waiter" @click="findCallWaiterReason();"/>
                </div>

                
              </div>
            </div>
          </div>
          <div v-else>

            <TableShimmer
              :error="ordersError"
              :count="15"
              :state="isFilterByCallWaiter 
                      ? $t('menuOrder.order.state.callWaiter') 
                      : selectedStatus === 1 
                        ? $t('menuOrder.order.state.open') 
                        : $t('menuOrder.order.state.new')"
              @show-all="selectedStatus = null , isFilterByCallWaiter= false"
            />
            
          </div>
        </div>

        <div
          class="transition-col-right bg-white border rounded p-3 shadow d-none d-sm-block"
          :class="{ visible: selectedTableNumber, hidden: !selectedTableNumber }"
        >
          <OrderTableDetails ref="orderDetailsRef" @refresh="refresh()" v-if="selectedTableNumber" :menuItems="itemsList" :orderTable="selectedOrderTable" @cancel="closeDetails()" />

        </div>
      </div>


        <div class="d-flex justify-content-start" >
          <button style="z-index:1000;"
            class="btn btn-danger mt-2 text-uppercase font-weight-bold mr-2 ml-2 mt-md-2 mt-4 text-uppercase font-weight-bold p-3"
            :class="isMobile ? 'w-100' : 'w-md-auto'"
            @click="archivedAll()"
          >
            {{ $t('menuOrder.order.button.archivedAll') }}
          </button>
        </div>


    </div>

    <b-modal
      v-model="showModalOrderDetails"
      centered
      hide-header
      hide-footer
      size="sm"
      @hide="showModalOrderDetails = false"
    >
      <OrderTableDetails ref="orderDetailsRef" :isMobile="true"  @refresh="refresh()" v-if="selectedTableNumber" :menuItems="itemsList" :orderTable="selectedOrderTable" @cancel="closeDetails()"/>

    </b-modal>


      <Footer />
      <MobileFooter/>


  </div>
</template>

<style scoped>
.dashboard {
  background: #f8f9fa;
  color: #333;
  min-height: 100vh;
}

.section-title {
  color: #222;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.order-item {
  background: #fff;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 0.9rem;
  transition: 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}
.order-item:hover {
  background: #f1f1f1;
}
.order-badge {
  background: #0d6efd;
  color: white;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.75rem;
}

.table-card {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 10px;
  transition: all 0.3s ease;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
.table-card:hover {
  transform: translateY(-5px);
  background: #fdfdfd;
}

.table-shape {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.08);
}

.table-card::before,
.table-card::after {
  content: "";
  position: absolute;
  width: 120px;
  height: 11px;
  background: #ccc;
  border-radius: 20%;
}

@media (min-width: 600px) and (max-width: 1000px) {
  .table-card::before,
  .table-card::after {
    width: 80px;
  }
}

.table-card::before {
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
}
.table-card::after {
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
}
.table-card .chair {
  position: absolute;
  width: 11px;
  height: 120px;
  background: #ccc;
  border-radius: 20%;
}

@media (min-width: 600px) and (max-width: 1000px) {
  .table-card .chair {
    height: 80px;
  }
}

.table-card .chair.left {
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
}
.table-card .chair.right {
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
}

.table-card::before,
.table-card::after,
.table-card .chair {
  background: var(--status-color);
}

.order-indicator {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color:var(--status-color) ;
  box-shadow: 0 0 5px var(--status-color);
  animation: pulse 1.5s infinite;
  font-size: 0.8rem;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}

.waiter-j-call {
  position: absolute;
  top: 12px;
  left: 12px;
  color: var(--status-color);
  font-size: 0.8rem;

  animation: pulse 1.5s infinite;
}



.button-filter {
  color:  var(--status-font-color);
}


.button-filter.active {
  font-weight: bold;
  text-transform: uppercase;
  color: #ffffff;
  background: var(--status-background-color) !important ;
}


</style>


<style>

.row.d-flex {
  flex-wrap: nowrap;
}

.transition-col-left {
  transition: width 0.5s ease, padding 0.3s ease, margin 0.3s ease;
}

.transition-col-left.full {
  width: 100%;
}

.transition-col-left.shrink {
  width: 50%;
}

@media (min-width: 768px) {
  .transition-col-left.shrink {
    width: 60%;
  }
}

@media (min-width: 992px) {
  .transition-col-left.shrink {
    width: 60%;
  }
}

@media (min-width: 1200px) {
  .transition-col-left.shrink {
    width: 75%;
  }
}

.transition-col-right {
  position: sticky;
  top: 1rem;
  max-height: calc(100vh - 2rem); /* viewport height minus top offset */
  overflow-y: auto;
  transition: width 0.5s ease, opacity 0.5s ease;
  width: 100%;
  opacity: 0;
  pointer-events: none;
}

/* Visible state */
.transition-col-right.visible {
  opacity: 1;
  pointer-events: auto;
}

@media (max-width: 767.98px) {
  .transition-col-right.visible {
    width: 50%;
    order: 1;
    margin-bottom: 1rem;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .transition-col-right.visible {
    width: 40%;
  }
}

@media (min-width: 992px) {
  .transition-col-right.visible {
    width: 40%;
  }
}

@media (min-width: 1200px) {
  .transition-col-right.visible {
    width: 25%;
  }
}

.transition-col-right.hidden {
  width: 0;
  opacity: 0;
  pointer-events: none;
}

@keyframes blink-opacity {
  0%, 100% {
    opacity: 1;
  }
  20% {
    opacity: 0;
  }
}


.blinking-badge {
  animation: blink-opacity 1s infinite;
}
</style>